interface Props {
  children: React.ReactNode
  subtitle?: string
}

export default function PageHeading({ children, subtitle }: Props) {
  return (
    <div className="mt-6 shrink-0">
      <h1 className="custom-heading mb-2">{children}</h1>
      {subtitle && <p className="custom-subheading">{subtitle}</p>}
    </div>
  )
}
